// removed by extract-text-webpack-plugin
module.exports = {"formSearch":"formSearch_formSearch_1urAn","sameClassCP":"formSearch_sameClassCP_2ZkDN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/baseInfo/common/formSearch.scss
// module id = 605
// module chunks = 0